// host-configurable via hostSettings.gangSheet.maxTotalCopies; this is the fallback cap
export const DEFAULT_MAX_TOTAL_COPIES = 500;

export const MIN_GAP_MM = 0;
export const MAX_GAP_MM = 20;

// edge margin is independent of the gap: 0 is valid (e.g. the product already carries
// bleed), and it may need to exceed the inter-design gap for press/cutter tolerance
export const MIN_MARGIN_MM = 0;
export const MAX_MARGIN_MM = 50;

// nested pieces are either kept upright or turned by a quarter — nestOnSheet only
// distinguishes rotated/not rotated
export const GANG_SHEET_ROTATION_DEG = 90;

// new artwork lands on the sheet at its physical size at this print resolution (unless
// the host overrides it via hostSettings.gangSheet.defaultImageDpi)
export const GANG_SHEET_DEFAULT_IMAGE_DPI = 300;

// starting value for the buyer-adjustable edge margin — the unprinted border Auto nest
// keeps clear of the sheet edges, so nothing lands where the press or cutter cannot
// reach. Independent of the gap between designs; host-overridable via
// hostSettings.gangSheet.defaultMarginMm.
export const GANG_SHEET_DEFAULT_MARGIN_MM = 10;
